import { SectionGenerator } from 'util/DJGenerator';

export const SheetTableMapBuilder = (props) => {
  return {
    title: 'Select suitable columns for given data',
    buttons: [
      {
        title: 'Submit',
        deep_link: props.submitDeeplink,
      },
    ],
    sections: [
      {
        ...SectionGenerator({
          cards: props.columns.map((column) => ({
            type: 'card_35',
            hint: `${column.mappingTitle || column.title} Column`,
            key: column.key,
            selection: props.sheetHeaders,
          })),
        }),
      },
    ],
  };
};
export const ConfirmDialogBuilder = (props) => {
  return {
    title: props.title,
    buttons: [
      {
        title: 'Proceed',
        apiType: props.apiType || 2,
        deep_link: props.submitDeeplink,
      },
    ],
    sections: [
      {
        ...SectionGenerator({
          cards: [
            {
              type: 'card_75',
              heading: ``,
              subHeading: props.message,
            },
          ],
        }),
      },
    ],
  };
};

export const SheetMappingTableBuilder = (props) => {
  return {
    title: 'Select suitable columns for your data',
    sections: [
      {
        type: !!props.title ? 'card_heading' : 'khali_section',
        content: {
          title: props.title,
        },
        tables: [
          {
            tableKey: props.tableKey,
            enableMultipleSelect: true,
            tableActions: [
              {
                iconId: 1,
                name: 'Save',
                deep_link: props.submitDeeplink,
              },
            ],
            aggregateActions: [
              {
                iconId: 1,
                name: 'Save Selected',
                deep_link: props.submitDeeplink,
              },
            ],
            columns: [
              {
                title: 'Sheet Name',
                key: 'title',
                columnContentType: {
                  columnType: 0,
                  dataType: 0,
                },
              },
              ...(props.columns.map((column) => ({
                title: `${column.title} Column`,
                key: column.key,
                isEditable: true,
                columnContentType: {
                  columnType: 1,
                  dataType: 100,
                  isRequired: ((column || {}).columnContentType || {})
                    .isRequired,
                },
                selection: [],
              })) || []),
            ],
            rows: (props.sheetNames || []).map((sheetName) => ({
              id: sheetName,
              title: { value: sheetName },
              ...(props.columns.reduce(
                (cellCollection, currentColumn) => ({
                  ...cellCollection,
                  [currentColumn.key]: {
                    selection: (props.sheetHeaderSet || {})[sheetName],
                  },
                }),
                {}
              ) || {}),
            })),
          },
        ],
      },
    ],
  };
};
